import { FC } from 'react'

import { TArticleItem } from 'store/types/article'

import { ArticlesGrid } from './ui/ArticlesGrid/ArticlesGrid'

import styles from './styles.module.scss'

type ArticlesListProps = {
	urlLocation: string
	title: string
	news: TArticleItem[]
}

export const ArticlesList: FC<ArticlesListProps> = ({ urlLocation, title, news }) => (
	<section className={styles.articlesList}>
		<h1 className={styles.title}>{title}</h1>
		<div className={styles.inner}>
			<ArticlesGrid urlLocation={urlLocation} items={news} />
		</div>
	</section>
)
